import { ada, bit, eth, SP, up, down } from "../../../../utils";

export type Data = {
  img: any;
  alt: string;
  cryptoName: string;
  cryptoBalance: number;
  cryptoStatus: any;
  cryptoPercent: string;
};

export const data: Data[] = [
  {
    img: SP,
    alt: "S&P",
    cryptoName: "S&P 500",
    cryptoBalance: 511.28,
    cryptoStatus: down,
    cryptoPercent: "-3.01%",
  },
  {
    img: eth,
    alt: "ETH",
    cryptoName: "ETH",
    cryptoBalance: 4002.04,
    cryptoStatus: up,
    cryptoPercent: "+32.67%", // Add quotes and change type to string
  },
  {
    img: bit,
    alt: "BTC",
    cryptoName: "BTC",
    cryptoBalance: 71600.8,
    cryptoStatus: up,
    cryptoPercent: "+24.31%",
  },
  {
    img: ada,
    alt: "ADA",
    cryptoName: "ADA",
    cryptoBalance: -0.04,
    cryptoStatus: down,
    cryptoPercent: "-3.01%",
  },
  {
    img: eth,
    alt: "ETH",
    cryptoName: "ETH",
    cryptoBalance: 4002.04,
    cryptoStatus: up,
    cryptoPercent: "+32.67%",
  },
];
